import React from "react";
import "./IssueApiKey.css";

const IssueApiKey = () => {
  return <div>Issue Api Key screen</div>;
};

export default IssueApiKey;
